<template>
    <div class="content-card">
      <div class="card-type">
        <label class="label inline-block">类型</label>
        <span class="tag" :class="{'is-info':source.articleType == 0,'is-success':source.articleType == 1}">{{getArticleType(source.articleType)}}</span>
      </div>
      <div class="card-title" v-html="source.title"></div>
      <div class="img-container clearfix lightgallery">
        <div class="img-item" v-for="(imageItem,imgIndex) in source.images" @click="onImagePreviewClick($event,imgIndex,source.images)">
          <image-component :image="imageItem" :width="cardStyle.width" :height="cardStyle.height" :compress="1.2"></image-component>
        </div>
      </div>
      <div class="publish-time">
        {{source.publishTime}} <span>发帖</span>
      </div>
      <div class="user clearfix">
        <!--<div class="avatar fleft"><image-component :image="avatar" :width="50" :height="50"></image-component></div>-->
        <div class="user-name fleft">{{source.source}}  {{source.accountName}}</div>
      </div>
      <div class="tags">
        <label class="label inline-block r-top">ICON标签:</label>
        <button class="button is-info" @click="addIcon">添加</button>
      </div>
      <div class="tags">
          <span class="tag is-warning is-medium" v-for="(tagItem,tagIndex) in selectIconTags">
                {{tagItem.name}}
                <button class="delete is-small" @click="onDelIconTag(tagIndex,tagItem.tagId)"></button>
              </span>
      </div>
      <el-dialog title="添加ICON标签" :visible.sync="visible" :lock-scroll="false">
        <div class="select-box">
          <label class="label">标签名称</label>
          <el-select v-model="updateIconTags" filterable multiple placeholder="请选择" @change="updateIconTagsOpt">
                  <el-option
                    v-for="item in iconTagsAllList"
                    :key="item.name"
                    :label="item.accountName"
                    :value="item.name">
                  </el-option>
                </el-select>
          <!-- <v-select :options="iconTagsAllList" :selected="selectIconTags"  :show-labels=false label="name" :multiple="true"
              key="name" @update="updateIconTagsOpt" placeholder="请选择"></v-select> -->
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="visible = false">取 消</el-button>
          <el-button type="primary" @click="MODAL_OK_EVENT">确 定</el-button>
        </span>
      </el-dialog>
    </div>
</template>
<script type="text/babel">
  import {mapActions} from 'vuex';
  import {onImagePreviewClick} from 'UTILS/imagePreview'


  export default {
    props:{
      source:{
        type:Object,
        require:true
      },
      iconTagsAllList:{
        type:Array,
        require:true
      }
    },
    data(){
      return {
        visible:false,
        modalBodyStyle:{
        'overflow-x': 'initial',
        'overflow-y': 'initial'
        },
        selectIconTags:[],//被格式化展示的tags
        updateIconTags:[],//选择更新的tags
        updateIconTagsOptChange:false//是否更新过标签
      }
    },
    computed:{
      cardStyle(){
        if(_.size(this.source.images) > 2){
          return {
            width:100,
            height:100
          }
        }
        return {
          width:150,
          height:200
        }
      }
    },
    created(){
      this.selectIconTags = this.source.tags;
    },
    methods: {
      ...mapActions([
        'commitWaterfallUpdate'
      ]),
      /**
       * 添加属性标签
       */
      MODAL_OK_EVENT(data){
        if(!this.updateIconTagsOptChange){
          return
        }
        let updateIconTags = [];
        _.each(this.updateIconTags,(item,index)=>{
          updateIconTags.push(_.findWhere(this.iconTagsAllList, {name:item}));
        })
        this.selectIconTags = updateIconTags;
        let _tagsArr = [];
        _.each(this.selectIconTags,(item,index)=>{
          _tagsArr.push(item.tagId)
        });
        let params = {
          feedId:this.source.feedId,
          tagIds:_tagsArr
        }
        this.doSaveTag(params);
        this.commitWaterfallUpdate()
      },
      onImagePreviewClick:onImagePreviewClick,
      //添加ICON分类展示弹窗
      addIcon(){
        this.visible = true;
        this.updateIconTags = []
        _.each(this.selectIconTags,(item,index)=>{
          this.updateIconTags.push(item.name)
        })
      },
      //更新标签选择
      updateIconTagsOpt(data){
        this.updateIconTagsOptChange =  true;
        this.updateIconTags = data;
      },
      //删除标签标签
      onDelIconTag(tagIndex,tagId){
        this.selectIconTags.splice(tagIndex,1);
        let _tagsArr = [];
        _.each(this.selectIconTags,(item,index)=>{
          _tagsArr.push(item.tagId)
        });
        let params = {
          feedId:this.source.feedId,
          tagIds:_tagsArr
        }
        this.doSaveTag(params);
      },
      /**
       * 保存ICON标签修改
       * */
      doSaveTag(params){
        HttpRequest.post('/admin.php?method=fashion.doSaveFeedIconTag',params).then(response => {
          this.commitWaterfallUpdate(true);
          this.visible = false;
        })
      },
      getArticleType(articleType){
        if(articleType === 0){
          return "图集"
        }else if(articleType === 1){
          return "文章"
        }
      }
    }
  }
</script>
<style lang="less" scoped>
  .content-card {
    position: relative;
    width: 360px;
    border: 1px solid #d3d6db;
    border-radius: 6px;
    background-color: #fff;
    padding: 10px 20px;
    margin-bottom: 20px;
    .card-type {
      margin-bottom: 10px;
      .tag {
        border-radius: 3px;
        margin-left: 5px;
      }
    }
    .card-title {
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      overflow: hidden;
      font-size: 15px;
      color: #333;
      margin-bottom: 10px;
    }
    .img-container {
      .img-item {
        float: left;
        margin-left: 5px;
        margin-top: 5px;
      }
    }
    .publish-time {
      height: 40px;
      line-height: 40px;
      span {
        color:#4dc340;
      }
    }
    .user {
      .avatar {
        width: 50px;
        height: 50px;
        border-radius: 100%;
        overflow: hidden;
      }
      .user-name {
        height:50px;
        line-height: 50px;
        color:#333;
        font-size: 16px;
      }
    }
    .tags {
      .tag {
        border-radius: 3px;
        margin-right: 10px;
      }
    }
  }
  .select-box{
    width: 560px;
  }
  .tags{
    margin-top: 10px;
    .tag{
      margin-bottom: 10px;
    }
  }
</style>
